import { Type, Static } from '@sinclair/typebox';
import {
  defineSchema,
  SystemFields,
  StringField,
  SlugField,
  BooleanField,
} from '@ayocore/platform/common/helpers/schema-types';

import { name as moduleName } from '../module.json';
/**
 * Типы сделок — определяют воронку для сделок.
 */
export const DealTypeSchema = Type.Object({
  ...SystemFields,
  name: StringField({
    title: 'Название типа сделки',
    minLength: 1,
    maxLength: 100,
    description: 'Название типа сделки (например, "Сделка", "Повторная продажа")',
  }),
  slug: SlugField({
    title: 'Slug',
    description: 'Уникальный код типа сделки (например, DEAL, REPEAT)',
  }),
  description: StringField({
    title: 'Описание',
    nullable: true,
    maxLength: 500,
    description: 'Описание типа сделки',
  }),
  is_active: BooleanField({
    title: 'Активен',
    default: true,
    description: 'Тип сделки активен и доступен для выбора',
  }),
});

export type DealType = Static<typeof DealTypeSchema>;

export default defineSchema({
  moduleName,
  tableName: 'deal_types', // System will prefix with 'crm_'
  schema: DealTypeSchema,
  additionalIndexes: ['name', { columns: ['slug'], unique: true }, 'is_active'],
});
